import request from '@/utils/request'

// 查询银河打本剧本分页
export function pageScript(query) {
  return request({
    url: '/played/script/page',
    method: 'get',
    params: query
  })
}

// 查询银河打本剧本列表
export function listScript(query) {
  return request({
    url: '/played/script/list',
    method: 'get',
    params: query
  })
}

// 查询银河打本剧本详细
export function getScript(scriptId) {
  return request({
    url: '/played/script/' + scriptId,
    method: 'get'
  })
}

// 新增银河打本剧本
export function addScript(data) {
  return request({
    url: '/played/script',
    method: 'post',
    data: data
  })
}

// 修改银河打本剧本
export function updateScript(data) {
  return request({
    url: '/played/script',
    method: 'put',
    data: data
  })
}

// 删除银河打本剧本
export function delScript(scriptId) {
  return request({
    url: '/played/script/' + scriptId,
    method: 'delete'
  })
}
